<template>
    <div class="animated fadeIn">
        <component-header
            title="Stock Points"
            @search-query="(val) => (search = val)"
            :isLoading="loading"
            @reload-data="getStockpointList"
            @create-press="createOffice"
        />

        <div v-if="loading" class="loading-container">
            <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
            />
        </div>
        <b-card class="card-wrap" border-variant="info">
            <div class="mt-3">
                <b-table
                    :fields="partnerColumns"
                    :items="partners"
                    class="table-bordered table-sm"
                    :dark="dark"
                    :filter="search"
                    :hover="hover"
                    thead-class="header"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    show-empty
                    ref="partners"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :per-page="perPage"
                >
                    <template slot="cell(name)" slot-scope="data">
                        <div class="table-row">{{ data.userName }}</div>
                    </template>
                    <template slot="cell(action)" slot-scope="data">
                        <b-button
                            size="sm"
                            class="mr-2"
                            variant="primary"
                            @click="viewSubOffice(data.item)"
                        >
                            <i class="fa fa-eye"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
            <div class="pagination-wrapper">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="partnersMeta.total"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                    @change="getTenantData"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "viewattribute",
    components: {
        ComponentHeader,
        AtomSpinner,
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            loading: false,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            search: "",
            partner: {},
            sortBy: "createdAt",
            sortDesc: true,
            category: "",
            partnerColumns: [
                {
                    key: "userName",
                    sortable: true,
                },
                {
                    key: "email",
                },
                {
                    key: "phone",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            partnersMeta: (state) => state.partner.partnerListMeta,
        }),
        partners() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let partnerList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    if (obj.category == "STOCK_POINT") {
                        let arrayObj = {
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            ...obj,
                        };
                        partnerList.push(arrayObj);
                    }
                });
                return partnerList;
            } else {
                return [];
            }
        },
    },
    methods: {
        async getTenantData(e) {
            this.currentPage = e;
            await this.getStockpointList();
        },
        viewSubOffice(data) {
            this.$store.dispatch("partner/editPartnerData", data);
            this.$router.push("/suboffice-management/view");
        },
        createOffice() {
            this.$router.push("/suboffice-management/create");
        },
        async getStockpointList() {
            this.loading = true;
            const payload = {
                limit: this.perPage,
                page: this.currentPage,
                category: "STOCK_POINT",
            };
            await this.$store
                .dispatch("partner/fetchPartnersList", payload)
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.loading = false;
                    }
                    this.loading = false;
                });
        },
    },
    watch: {
        search(value) {
            this.currentPage = 1;
        },
    },
    async mounted() {
        await this.getStockpointList();
    },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px

.loading-container
  min-height: 200px
  display: flex
  align-items: center
  justify-content: center
  background-color: rgba(255, 255, 255, 0.5)
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 9999

.pagination-wrapper 
  float: right
  margin-top: 1rem


@media (max-width: 576px) 
  .pagination-wrapper 
    float: none
    text-align: center
  
</style>
